import React, { Component, PropTypes } from 'react';
import { findDOMNode } from 'react-dom';
import accepts from 'attr-accept';
import { Colors } from 'components/Material/Styles/Colors';
import { maxFileSize } from 'Constants';
import AppActions from 'actions/App';

export default class Dropzone extends Component {
  static defaultProps = {
    supportClick: true,
    multiple: true
  };

  state = {
    isDragActive: false
  };

  static propTypes = {
    onProgress: PropTypes.func,
    onSuccess: PropTypes.func,
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    height: PropTypes.number,
    lineHeight: PropTypes.number,
    style: PropTypes.object,
    supportClick: PropTypes.bool,
    accept: PropTypes.string,
    multiple: PropTypes.bool
  };

  componentDidMount() {
    this.enterCounter = 0;
  }

  onDragLeave(e) {
    e.preventDefault();
    // Only deactivate once the dropzone and all children was left.
    if (--this.enterCounter > 0) {
      return;
    }

    this.setState({
      isDragActive: false,
      isDragReject: false
    });

    if (this.props.onDragLeave) {
      this.props.onDragLeave.call(this, e);
    }
  }

  allFilesAccepted(files) {
    return files.every(file => accepts(file, this.props.accept));
  }

  onDragOver(e) {
    e.preventDefault();
    e.stopPropagation();
    return false;
  }

  onDragEnter(e) {
    e.preventDefault();
    e.dataTransfer.dropEffect = 'copy';
    ++this.enterCounter;

    // This is tricky. During the drag even the dataTransfer.files is null
    // But Chrome implements some drag store, which is accesible via dataTransfer.items
    const dataTransferItems =
      e.dataTransfer && e.dataTransfer.items ? e.dataTransfer.items : [];

    // Now we need to convert the DataTransferList to Array
    const allFilesAccepted = this.allFilesAccepted(
      Array.prototype.slice.call(dataTransferItems)
    );


    this.setState({
      isDragActive: allFilesAccepted,
      isDragReject: !allFilesAccepted
    });

    if (this.props.onDragEnter) {
      this.props.onDragEnter.call(this, e);
    }
  }

  handleFile(files) {
    if (files.length < 1) {
      return;
    }
    const current = files.pop();
    if (current) {
      const fileType = current.type;
      const encoded =
        fileType.indexOf('audio') === 0 || fileType.indexOf('video') === 0;
      SteelCompass.upload([current], {
        encoded,
        progress: event => {
          if (this.props.onProgress && event) {
            this.props.onProgress({
              ...event,
              remaining: files.length
            });
          }
        },
        error: res => {
          if (res && res.errMsg) {
            AppActions.notify(res.errMsg);
          }
          if (files.length > 0) {
            this.handleFile(files);
          }
        },
        success: response => {
          if (response && response.data && this.props.onSuccess) {
            this.props.onSuccess(response.data);
          }
          if (files.length > 0) {
            this.handleFile(files);
          }
        }
      });
    }
  }

  onChange(e) {
    this.processFiles(e.target.files);
  }

  processFiles(files) {
    const fileList = Object.keys(files).map(key => files[key]);
    const willBeUploaded = fileList.filter(file => file.size < maxFileSize);
    const willBeDropped = fileList.filter(file => file.size >= maxFileSize);
    if (willBeDropped.length > 0) {
      if (willBeDropped.length > 1) {
        AppActions.notify(willBeDropped.length + ' files are too big.');
      } else {
        AppActions.notify(willBeDropped.length + ' file is too big.');
      }
    }
    if (willBeUploaded.length > 0) {
      this.handleFile(willBeUploaded);
    }
  }

  onDrop(e) {
    e.preventDefault();

    if(!!this.state.isDragReject){
      return
    }

    this.setState({
      isDragActive: false
    });

    let files;
    if (e.dataTransfer) {
      files = e.dataTransfer.files;
    } else if (e.target) {
      files = e.target.files;
    }

    let maxFiles = this.props.multiple ? files.length : 1;
    for (let i = 0; i < maxFiles; i++) {
      files[i].preview = URL.createObjectURL(files[i]);
    }

    files = Array.prototype.slice.call(files, 0, maxFiles);
    this.processFiles(files);
  }

  onClick() {
    if (this.props.supportClick === true) {
      this.open();
    }
  }

  open() {
    let fileInput = findDOMNode(this.refs.fileInput);
    fileInput.value = null;
    fileInput.click();
  }

  render() {
    let className = this.props.className || 'dropzone';
    // if (this.state.isDragActive) {
    //   className += ' active';
    // }

    const style = Object.assign(
      {},
      {
        cursor: 'pointer',
        width: this.props.width || 100,
        height: this.props.height || 100,
        lineHeight:
          (this.props.lineHeight && this.props.lineHeight + 'px') || '24px',
        backgroundColor: this.state.isDragActive
          ? Colors.yellow[50].material
          : null
      },
      this.props.style
    );
    return (
      <div
        className={className}
        style={style}
        onDragLeave={this.onDragLeave.bind(this)}
        onDragOver={this.onDragOver.bind(this)}
        onDragEnter={this.onDragEnter.bind(this)}
        onDrop={this.onDrop.bind(this)}
      >
        {this.props.children}
        <input
          style={{ display: 'none' }}
          type="file"
          multiple={this.props.multiple}
          ref="fileInput"
          onChange={this.onChange.bind(this)}
          accept={this.props.accept}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/DropZone.js